<template>
  <div>
    <b-row v-if="idRevenda != 1">
      <div class="card-form">
        <div class="card-list">
          <div class="card-form-assinatura__inner">
            <div class="card-input" style="padding-top: 30px">
              <h3>Verifique sua assinatura com nosso Parceiro:</h3>
              <br />
              <h3 style="text-align: center">
                {{ dadosRevenda.nome_revenda }} <br />
                Telefone: {{ dadosRevenda.fone_revenda }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </b-row>

    <b-row v-if="showAssinaturaCard">
      <b-col md="12">
        <div class="card-form shadow">
          <div class="card-list">
            <div class="card-form-assinatura__inner text-center py-4 px-3">
              <h6 class="text-muted mb-3">
                Dúvidas? Entre em contato com nosso Comercial:
              </h6>
              <h2 class="text-primary mb-4">(49) 3550 0600</h2>
              <h2 class="mb-3">Assinatura:</h2>
              <h4>
                Sua licença expira no dia
                <strong>{{ formatDate(assinatura.data_validade) }}</strong
                >. Você está no plano <strong>{{ assinatura.plano }}</strong
                >.
              </h4>
              <div class="mt-4" v-if="assinatura.id_plan == 7">
                <b-button
                  variant="primary"
                  class="mr-2"
                  :disabled="isLoading"
                  @click="openUpgradeModal()"
                >
                  Upgrade para Essencial Mensal
                </b-button>
              </div>

              <!-- Opção de Pagamento -->
              <div
                v-if="
                  (licenca.apresentar_renovacao && assinatura.id_plan == 2) ||
                  assinatura.id_plan == 4
                "
              >
                <div class="opcoes-pagamento mt-4">
                  <h5>Selecione a forma de pagamento para renovação:</h5>

                  <b-form-select v-model="opcaoSelecionada" placeholder="">
                    <b-form-select-option
                      v-for="opcao in opcoesPagamento"
                      :key="opcao.id"
                      :value="opcao.id"
                    >
                      {{ opcao.descricao }}
                    </b-form-select-option>
                  </b-form-select>
                </div>

                <b-button
                  variant="success"
                  target="_blank"
                  class="mt-4"
                  :disabled="isLoading"
                  :loading="isLoading"
                  @click="renovarPorMaisUmAno"
                >
                  Renovar com a Nuts
                </b-button>

                <p class="mt-2 text-muted small">
                  <br />
                  <strong
                    >Obs: Ao renovar, os boletos e NFSe serão gerados e enviados
                    automaticamente para o e-mail abaixo:</strong
                  >
                  <b-col md="10">
                    <b-form-input
                      ref="email"
                      id="email"
                      name="email"
                      v-model="licenca.email"
                    />
                  </b-col>
                </p>

                <div class="mt-3">
                  <strong>
                    <a
                      href="https://wa.me/554935500600?text=Quero renovar meu sistema!"
                      target="_blank"
                      class="contato-link"
                    >
                      Clique aqui para falar com a Nuts!
                    </a>
                  </strong>
                </div>
              </div>

              <div
                v-if="
                  (licenca.apresentar_renovacao && assinatura.id_plan == 3) ||
                  assinatura.id_plan == 6
                "
              >
                <div class="opcoes-pagamento mt-4">
                  <h5>Clique no botão a baixo para renovar:</h5>

                  <b-button
                    variant="success"
                    target="_blank"
                    class="mt-4"
                    :disabled="isLoading"
                    :loading="isLoading"
                    @click="renovarPorMaisUmAno"
                  >
                    Renovar com a Nuts
                  </b-button>

                  <p class="mt-2 text-muted small">
                    <br />
                    <strong
                      >Obs: Ao renovar, os boletos e NFSe serão gerados e
                      enviados automaticamente para o e-mail abaixo:</strong
                    >
                    <b-col md="10">
                      <b-form-input
                        ref="email"
                        id="email"
                        name="email"
                        v-model="licenca.email"
                      />
                    </b-col>
                  </p>

                  <div class="mt-3">
                    <strong>
                      <a
                        href="https://wa.me/554935500600?text=Quero renovar meu sistema!"
                        target="_blank"
                        class="contato-link"
                      >
                        Clique aqui para falar com a Nuts!
                      </a>
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="plan__table" v-if="dataReady && !ocultaPlans">
      <b-col md="12">
        <div class="plan-picker card-form shadow p-3">
          <h4 class="mb-3">Escolha o plano ideal para seu negócio:</h4>

          <b-row>
            <b-col
              v-for="(plan, idx) in plans"
              :key="plan.id_plan || idx"
              md="6"
              class="mb-3"
            >
              <div
                class="plan-card"
                :class="{ 'is-selected': selectedPlanId === plan.id_plan }"
                @click="selectPlan(plan)"
              >
                <div class="plan-card__header">
                  <h5 class="m-0">{{ plan.name }}</h5>
                </div>

                <div class="plan-card__body">
                  <div class="price-line">
                    <span class="price">{{ plan.price }}</span>
                  </div>

                  <ul class="features" v-if="getFeatures(plan).length">
                    <li v-for="(feat, i) in getFeatures(plan)" :key="i">
                      {{ feat }}
                    </li>
                  </ul>

                  <b-form-radio
                    :value="plan.id_plan"
                    v-model="selectedPlanId"
                    name="planRadio"
                  >
                    Selecionar
                  </b-form-radio>
                </div>
              </div>
            </b-col>
          </b-row>

          <div
            class="d-flex flex-column flex-md-row align-items-start align-items-md-center mt-3 gap-2"
          >
            <b-button
              variant="primary"
              :disabled="!selectedPlanId"
              @click="pagarNoCartao"
              class="mr-2"
            >
              Pagar no cartão
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col :md="colMDCartao" v-if="chamaCartao">
        <b-button
          variant="outline-secondary"
          size="sm"
          class="mb-3"
          @click="chamaPlans"
        >
          ← Voltar e escolher outro plano
        </b-button>

        <CardForm
          v-show="chamaCartao"
          :form-data="formData"
          @input-card-number="updateCardNumber"
          @input-card-name="updateCardName"
          @input-card-month="updateCardMonth"
          @input-card-year="updateCardYear"
          @input-card-cvv="updateCardCvv"
          :plano="assinatura.plano"
          :valor="assinatura.valor"
          :id_plan="assinatura.id_plan"
          :vezesByPlan="vezesByPlan"
          :isSale="isSale"
        />
      </b-col>
    </b-row>

    <!-- BLOCO: Faturas / Assinaturas (boletos) -->
    <div
      class="bloco-faturas"
      v-if="
        assinatura.id_plan == 7 ||
        assinatura.id_plan == 3 ||
        assinatura.id_plan == 4 ||
        assinatura.id_plan == 6 ||
        assinatura.id_plan == 2
      "
    >
      <b-row>
        <b-col md="12">
          <b-card>
            <h6 class="mb-3">Histórico de faturas</h6>
            <b-table
              :items="itemsTable"
              :fields="fieldsAssinaturas"
              small
              responsive
              head-variant="light"
              :busy="assinaturasLoading"
            >
              <template #table-busy>
                <div class="text-center w-100 my-3">
                  <b-spinner class="mr-2" small></b-spinner>
                  Carregando faturas...
                </div>
              </template>
              <template #empty>
                <div class="text-center text-muted my-3">
                  Nenhuma fatura encontrada.
                </div>
              </template>

              <template #cell(data_vencimento)="row">
                {{ formatDate(row.item.data_vencimento) }}
              </template>

              <template #cell(valor)="row">
                R$ {{ formatValorReal(row.item.valor) }}
              </template>

              <template #cell(pagamento)="row">
                <b-badge
                  :variant="
                    row.item.pagamento
                      ? 'success'
                      : isOverdue(row.item)
                      ? 'danger'
                      : 'warning'
                  "
                >
                  {{
                    row.item.pagamento
                      ? "Paga"
                      : isOverdue(row.item)
                      ? "Vencida"
                      : "Pendente"
                  }}
                </b-badge>
              </template>

              <template #cell(acoes)="row">
                <div class="d-flex justify-content-end">
                  <b-button
                    v-if="row.item.url_boleto && row.item.pagamento === false"
                    :href="row.item.url_boleto"
                    target="_blank"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                  >
                    Abrir boleto
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- Modal de Confirmação de Upgrade -->
    <b-modal
      id="modal-upgrade-essencial"
      title="Confirmar upgrade de plano"
      :ok-title="isLoading ? 'Processando...' : 'Confirmar upgrade'"
      ok-variant="primary"
      cancel-title="Cancelar"
      :ok-disabled="isLoading"
      :hide-header-close="isLoading"
      :no-close-on-backdrop="isLoading"
      :no-close-on-esc="isLoading"
      @ok.prevent="confirmUpgrade"
    >
      <div>
        <p class="mb-2">
          Você está prestes a fazer upgrade para:
          <strong>Plano Essencial</strong>
        </p>
        <p class="mb-2">Valor: <strong>79,90</strong></p>
        <b-alert show variant="warning" class="mb-0">
          Ao confirmar, vamos atualizar sua assinatura e para o mês seguinte
          será cobrado o valor atualizado.
        </b-alert>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin, FormatMixin } from "@/modules/Application";
import { mapGetters, mapActions } from "vuex";
import AssinaturaData, { AssinaturaDataRequired } from "./AssinaturaData";
import CardForm from "../Cards/CardForm";

export default {
  name: "app-assinatura",
  mixins: [validationMixin, SistemaMixin, FormatMixin],
  components: { CardForm },
  data() {
    return {
      dataReady: false,
      ocultaPlans: false,
      colMDSignature: 5,
      colMDCartao: 12,
      tabIndex: 0,
      assinatura: {},
      formData: {
        cardName: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
      },
      cartao: {},
      chamaCartao: false,
      vezesByPlan: 1,
      essencialMonthly: "3",
      essencialYearly: "2",
      standardYearly: "4",
      planSelected: {},
      plans: [],
      isSale: false,
      opcaoSelecionada: null,
      opcoesPagamento: [
        { id: null, descricao: "Selecione uma opção" },
        { id: 1, descricao: "À vista Boleto" },
        { id: 2, descricao: "Parcelado Boleto - 15/30/60 dias" },
      ],
      isLoading: false,
      selectedPlanId: null,
      assinaturas: [],
      assinaturasLoading: false,
      printingId: null, // << chave de loading por linha (usa id do boleto)
    };
  },
  validations: { form: AssinaturaDataRequired },
  computed: {
    ...mapGetters(["itsblocked", "idRevenda", "dadosRevenda", "licenca"]),
    showAssinaturaCard() {
      return (
        this.idRevenda == 1 &&
        ["2", "4", "3", "6"].includes(String(this.licenca.id_plan))
      );
    },
    selectedPlan() {
      return (
        this.plans.find(
          (p) => String(p.id_plan) === String(this.selectedPlanId)
        ) || null
      );
    },
    currentInvoice() {
      if (!this.assinaturas?.length) return null;
      const byCreated = [...this.assinaturas].sort(
        (a, b) =>
          new Date(b.created_at || b.data_vencimento) -
          new Date(a.created_at || a.data_vencimento)
      );
      const ativa = byCreated.find(
        (a) => a.status === true || a.recebido === true
      );
      return ativa || byCreated[0];
    },
    pendingInvoice() {
      if (!this.assinaturas?.length) return null;
      const pend = this.assinaturas
        .filter((a) => a.assinatura_paga === false || a.recebido === false)
        .sort(
          (a, b) =>
            new Date(b.created_at || b.data_vencimento) -
            new Date(a.created_at || a.data_vencimento)
        );
      return pend[0] || null;
    },
    // Itens da tabela (boletos)
    itemsTable() {
      return [...(this.assinaturas || [])].map((b) => ({
        id: b.id, // <-- chave única da linha para loading
        data_vencimento: b.data_vencimento,
        valor: b.valor,
        pagamento: !!b.recebido,
        url_boleto: b.url_boleto,
        id_venda: b.id_venda || null,
        id_nfse: b.id_nfse || null,
        created_at: b.created_at || null,
      }));
    },
    fieldsAssinaturas() {
      return [
        { key: "data_vencimento", label: "Vencimento", sortable: true },
        { key: "valor", label: "Valor", sortable: true, class: "text-nowrap" },
        { key: "pagamento", label: "Pagamento", sortable: true },
        {
          key: "acoes",
          label: "Ações",
          thClass: "text-right",
          tdClass: "text-right text-nowrap",
        },
      ];
    },
  },
  async mounted() {
    if (this.itsblocked) this.$router.push({ name: "assinatura" });
    await this.getDataInit();
  },
  methods: {
    ...mapActions(["setLoading"]),
    updateCardNumber() {},
    updateCardName() {},
    updateCardMonth() {},
    updateCardYear() {},
    updateCardCvv() {},
    isOverdue(item) {
      // Se já foi paga, nunca é vencida
      if (item.pagamento) return false;

      // Normaliza "hoje" para 00:00:00
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Garante parsing consistente para 'YYYY-MM-DD'
      // Se vier só a data, força meia-noite local
      const parseDate = (d) => {
        if (!d) return null;
        // Suporta Date ou string
        if (d instanceof Date)
          return new Date(d.getFullYear(), d.getMonth(), d.getDate());
        // Se já vier no padrão 'YYYY-MM-DD'
        if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
          const [y, m, day] = d.split("-").map(Number);
          return new Date(y, m - 1, day);
        }
        // Fallback: deixa o JS parsear e normaliza
        const dt = new Date(d);
        if (isNaN(dt)) return null;
        return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
      };

      const due = parseDate(item.data_vencimento);
      if (!due) return false;

      // Vencida se data de vencimento é ANTES de hoje
      return due < today;
    },
    async getDataInit() {
      this.setLoading(true);
      const data = await this.getAssinaturaByClient();
      this.plans = await this.getPlans();

      if (!data || !data.id_empresa) {
        this.setLoading(false);
        return this.$toast.error("Assinatrura não encontrada!");
      }

      this.assinatura = new AssinaturaData(data);
      this.ocultaPlans = !(Number(this.assinatura.id_plan) === 1);
      this.dataReady = true;
      this.setLoading(false);

      this.assinaturasLoading = true;
      try {
        const dataAssinatuira = await this.$http.post(
          "/empresa/fatura-assinaturas"
        );
        this.assinaturas =
          (dataAssinatuira?.data && dataAssinatuira.data.assinaturas) || [];
      } finally {
        this.assinaturasLoading = false;
        this.setLoading(false);
      }
    },
    cadastrarCartao() {
      this.chamaCartao = true;
      this.colMDSignature = 6;
      this.ocultaPlans = true;
    },
    chamaPlans() {
      this.chamaCartao = false;
      this.ocultaPlans = false;
      this.planSelected = {};
      this.selectedPlanId = null;
      this.getDataInit();
    },
    isPrinting(item) {
      const key = String(item.id ?? "");
      return key && String(this.printingId) === key;
    },
    async postPlan(plan, isSale) {
      this.setLoading(true);
      this.$toast.success("Plano Selecionado com sucesso!");
      if (plan.id_plan == this.essencialYearly) this.vezesByPlan = 6;
      if (plan.id_plan == this.essencialMonthly) this.vezesByPlan = 1;
      this.assinatura.id_plan = plan.id_plan;
      this.chamaCartao = true;
      this.ocultaPlans = true;
      this.planSelected = plan;
      this.isSale = isSale;
      this.setLoading(false);
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      const delay = el.dataset.index * 150;
      setTimeout(() => {
        el.style.opacity = 1;
        setTimeout(() => done(), 500);
      }, delay);
    },
    leave(el, done) {
      const delay = el.dataset.index * 150;
      setTimeout(() => {
        el.style.opacity = 0;
        setTimeout(() => done(), 500);
      }, delay);
    },
    async renovarPorMaisUmAno() {
      this.isLoading = true;
      this.setLoading(true);
      try {
        await this.$http.post("/contrato-fatura/assinatura", {
          id_empresa: this.assinatura.id_empresa,
          id_assinatura: this.assinatura.id_assinatura,
          id_plan: this.assinatura.id_plan,
          parcelamento: this.opcaoSelecionada,
          cnpj_cpf: this.assinatura.cnpj_cpf,
          email_fatura: this.licenca.email,
        });
        this.$toast.success(
          "Assinatura renovada com sucesso, irá receber por e-mail os boletos da cobrança!"
        );
        this.$router.push({ name: "dashboard" });
      } catch (error) {
        this.$toast.danger(
          "Houve algum problema na sua renovação, chame um consultor da Nuts!"
        );
      } finally {
        this.isLoading = false;
        this.setLoading(false);
      }
    },
    selectPlan(plan) {
      this.selectedPlanId = String(plan.id_plan);
    },
    getFeatures(plan) {
      const arr = Array.isArray(plan.features) ? plan.features : [];
      return arr.map((obj) => obj[Object.keys(obj)[0]]).slice(0, 20);
    },
    pagarNoCartao() {
      if (!this.selectedPlanId)
        return this.$toast.danger("Selecione um plano para continuar.");
      this.assinatura.id_plan = this.selectedPlan.id_plan;
      this.vezesByPlan = 1;
      this.assinatura.plano = this.selectedPlan.name;
      this.assinatura.valor = this.assinatura.valor;
      this.planSelected = this.selectedPlan;
      this.isSale = true;
      this.chamaCartao = true;
      this.ocultaPlans = true;
      this.$nextTick(() => {
        const el =
          this.$el.querySelector(".card-form-assinatura__inner") || this.$el;
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },
    planName(idPlan) {
      const p = this.plans?.find((pp) => String(pp.id_plan) === String(idPlan));
      if (p?.name) return p.name;
      const map = {
        1: "Plano Free",
        2: "Plano Essencial - Anual",
        3: "Plano Essencial - Mensal",
        4: "Plano Standard - Anual",
        7: "Plano Basic - Mensal",
      };
      return map[String(idPlan)] || `Plano #${idPlan}`;
    },
    formatValorReal(value) {
      if (!value) return "0,00";
      const num = typeof value === "string" ? parseFloat(value) : value;
      return num.toLocaleString("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    openUpgradeModal() {
      this.$bvModal.show("modal-upgrade-essencial");
    },

    // IMPRESSÃO – loading por linha (printingId = item.id), backend recebe id_venda como id_nfse
    async handleImprimirNFSe(item) {
      if (!item) return;

      const idNFSe = item.id_venda || item.id_nfse || null; // usa id_venda; fallback id_nfse
      if (!idNFSe) {
        this.$toast?.danger?.("Não foi possível identificar a NFS-e (sem id).");
        return;
      }

      this.printingId = String(item.id); // chave única da linha

      try {
        const directUrl =
          item.nfse_url || item.url_pdf || item.link_pdf || null;
        if (directUrl) {
          window.open(directUrl, "_blank", "noopener");
          return;
        }

        const res = await this.$http.post("/nfse/imprimir-fatura", {
          id_nfse: idNFSe,
        });
        const url = res?.data?.nfse_url || res?.data?.url || res?.data?.link;
        if (url) {
          window.open(url, "_blank", "noopener");
          this.$toast?.success?.("PDF gerado com sucesso!");
        } else {
          this.$toast?.danger?.("Não foi possível gerar o PDF da NFS-e.");
        }
      } catch (e) {
        this.$toast?.danger?.("Erro ao gerar o PDF da NFS-e.");
      } finally {
        this.printingId = null;
      }
    },

    async carregarAssinaturas() {
      try {
        this.assinaturasLoading = true;
        const dataAssinatuira = await this.$http.post(
          "/empresa/fatura-assinaturas"
        );
        this.assinaturas =
          (dataAssinatuira?.data && dataAssinatuira.data.assinaturas) || [];
      } finally {
        this.assinaturasLoading = false;
      }
    },
    async confirmUpgrade(bvModalEvt) {
      try {
        if (bvModalEvt) bvModalEvt.preventDefault();
        this.isLoading = true;
        await this.$http.post("/empresa/fazer-upagrade");
        this.$toast.success("Upgrade feito com sucesso.");
        this.$router.push({ name: "dashboard" });
      } catch (e) {
        this.$toast.danger("Problema ao realizar upgrade.");
      } finally {
        this.$bvModal.hide("modal-upgrade-essencial");
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
@import "../../../assets/styles/styleCardPayment.scss";

$white: #fff;
$wild-sand: #f4f4f4;
$silver: #c9c9c9;
$contessa: black;
$astral: black;
$fountain-blue: #53bbb4;
$plan-colors: $contessa, $astral, $fountain-blue;
$radius: 3px;

.btn {
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: $radius;
  transition: all 250ms ease-in-out;
  &.is-fullwidth {
    width: 100%;
  }
}

.plan__table {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 1024px;
  margin: 0 auto;
}

.plan {
  flex: 1;
  padding: 1.5rem 1rem 2rem 1rem;
  margin: 1rem;
  background: $white;
  border-radius: $radius;
  box-shadow: 0 8px 12px 0 rgba(122, 122, 122, 0.2);
  transition: opacity 500ms linear, transform 250ms ease-in-out;
  &:hover {
    transform: scale(1.05) translateZ(0);
    backface-visibility: hidden;
  }
}

.plan__header {
  padding: 0.25rem 1rem;
  font-size: 1.25rem;
  font-weight: 500;
  color: $white;
  border-radius: $radius;
}

@for $i from 1 through length($plan-colors) {
  .plan:nth-child(#{$i}) {
    > .plan__header {
      background-color: nth($plan-colors, $i);
    }
    .plan__price {
      color: lighten(nth($plan-colors, $i), 25%);
    }
    .btn {
      background-color: nth($plan-colors, $i);
      &:hover {
        background-color: darken(nth($plan-colors, $i), 5%);
      }
    }
  }
}

.plan__price-box {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  > .plan__currency {
    align-self: center;
  }
  > .plan__price {
    margin-top: 10px;
    font-size: 1.5rem;
    font-weight: 600;
  }
  > .plan__period {
    align-self: flex-end;
  }
}

.plan__features {
  padding: 1rem 0.5rem;
}
.plan__feature {
  position: relative;
  padding-left: 2rem;
}
.plan__feature::before {
  background-size: 2rem;
  width: 2rem;
  height: 2rem;
  position: absolute;
  left: 0;
  color: #307aab;
}
.plan__footer {
  padding-top: 1rem;
}
.text-white {
  color: $white;
}

@media only screen and (max-width: 768px) {
  .plan__table {
    flex-direction: column;
  }
}

.card-form {
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.card-form-assinatura__inner {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.text-primary {
  color: #007bff;
}
.text-muted {
  color: #6c757d;
}
.destaque {
  font-size: 1.25rem;
  padding: 0.75rem 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}
.contato-link {
  font-size: 0.9rem;
  text-decoration: underline;
  color: #007bff;
}
.contato-link:hover {
  text-decoration: none;
}

.plan-picker .plan-card {
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #fff;
  transition: transform 120ms ease, box-shadow 120ms ease,
    border-color 120ms ease;
  &.is-selected {
    border-color: #007bff;
    box-shadow: 0 6px 14px rgba(0, 123, 255, 0.15);
  }
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
  }
  .plan-card__header {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #eee;
    background: #f7f9fc;
    border-radius: 10px 10px 0 0;
  }
  .plan-card__body {
    padding: 1rem;
    .price-line {
      display: flex;
      align-items: baseline;
      gap: 6px;
      margin-bottom: 0.5rem;
      .price {
        font-size: 1.35rem;
        font-weight: 700;
      }
    }
    .features {
      margin: 0.5rem 0 0.75rem 0;
      padding-left: 1rem;
      li {
        list-style: disc;
        margin-bottom: 0.25rem;
        color: #5b5b5b;
      }
    }
  }
}

/* responsividade / layout dos cards */
.plan__table {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 16px;
}
.plan {
  flex: 1 1 280px;
  position: relative;
  z-index: 0;
  transition: transform 120ms ease, box-shadow 120ms ease;
}
.plan:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}
.plan__table {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 16px;
}
.plan {
  flex: 1 1 280px;
  position: relative;
  z-index: 0;
  transition: transform 120ms ease, box-shadow 120ms ease;
  will-change: transform;
}
.plan:hover {
  transform: scale(1.02);
  z-index: 3;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.14);
}

/* bloco de faturas */
.bloco-faturas {
  position: relative;
  z-index: 1;
  margin-top: 150px;
}
</style>
